import AudioContainer from "@educaplay/core/GameProvider/GameProviderScore/Results/Result/AudioContainer";
import { CARD_TYPES } from "../../../utils/consts";
import { ImageComponent, TextContainer } from "@educaplay/core";
import clsx from "clsx";
import classes from "./resultNode.module.scss";

export default function ResultNode({ cardData, idx, isCorrect }) {
  switch (cardData.type) {
    case CARD_TYPES.AUDIO:
    case CARD_TYPES.AUDIOTEXT:
      return (
        <div
          className={clsx(
            classes.answer,
            isCorrect ? classes.rightAnswer : classes.wrongAnswer
          )}
        >
          <div className={classes.cardNumber}>{`${idx}`}</div>
          <AudioContainer source={cardData.src} />
          <TextContainer className={classes.text} text={cardData.text} />
        </div>
      );
    case CARD_TYPES.IMAGE:
    case CARD_TYPES.IMAGETEXT:
      return (
        <div
          className={clsx(
            classes.answer,
            isCorrect ? classes.rightAnswer : classes.wrongAnswer
          )}
        >
          <div className={classes.cardNumber}>{`${idx}`}</div>
          <ImageComponent
            source={cardData.src}
            className={classes.imageComponent}
          />
          <TextContainer className={classes.text} text={cardData.text} />
        </div>
      );
    case CARD_TYPES.TEXT:
      return (
        <div
          className={clsx(
            classes.answer,
            isCorrect ? classes.rightAnswer : classes.wrongAnswer
          )}
        >
          <div className={classes.cardNumber}>{`${idx}`}</div>
          <TextContainer className={classes.text} text={cardData.text} />
        </div>
      );
    default:
      return <> - </>;
  }
}
